import { render, staticRenderFns } from "./OrgTokens.vue?vue&type=template&id=702247b6&"
import script from "./OrgTokens.vue?vue&type=script&lang=js&"
export * from "./OrgTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports